import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { BUTTON_GROUP_ALIGNMENT, BUTTON_ICON_SIZE } from './Button.constants.js';
import { ButtonBase } from './ButtonBase.styles.js';
export { ButtonBase, InteractiveStyles, getPaletteForVariant } from './ButtonBase.styles.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var Button = styled(ButtonBase)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  border-color: transparent;\n  border-radius: ", ";\n  border-width: ", ";\n  display: flex;\n  justify-content: center;\n  position: relative;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizing.xxtiny;
}, function (_ref3) {
  var $variant = _ref3.$variant,
    $isPending = _ref3.$isPending;
  return $isPending && $variant === 'ghost' && 'transparent';
});
var getCircleSize = function getCircleSize(_ref4) {
  var theme = _ref4.theme,
    $size = _ref4.$size;
  switch ($size) {
    case BUTTON_ICON_SIZE.LARGE:
      return theme.sizing.huge;
    case BUTTON_ICON_SIZE.SMALL:
      return theme.sizing.large;
    case BUTTON_ICON_SIZE.TINY:
      return theme.sizing.medium;
    case BUTTON_ICON_SIZE.REGULAR:
    default:
      return theme.sizing.xlarge;
  }
};
var ButtonCircle = styled(ButtonBase)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  height: ", ";\n  width: ", ";\n  position: relative;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.primary;
}, getCircleSize, getCircleSize);
var LoadingContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  background-color: inherit;\n  padding: inherit;\n  border-radius: inherit;\n  color: ", ";\n"])), function (_ref6) {
  var $variant = _ref6.$variant,
    theme = _ref6.theme;
  return $variant === 'ghost' ? theme.colours.ink.primary.main : 'inherit';
});
styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var StyledGroup = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  border-radius: ", ";\n  background-color: ", ";\n  ", "\n  width: fit-content;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.borderRadius.primary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colours.canvas.secondary.main;
}, function (_ref9) {
  var $alignment = _ref9.$alignment;
  return $alignment === BUTTON_GROUP_ALIGNMENT.VERTICAL && 'flex-direction: column;';
});

export { Button, ButtonCircle, LoadingContainer, StyledGroup };
//# sourceMappingURL=Button.styles.js.map
